import { useEffect, useState } from "react";
// import Lottie from "react-lottie";
import { useParams, useSearchParams } from "react-router-dom";
// import animationData from "../../../../../common/assets/lottie/confetti_animation.json";
import useVerifyDonation from "features/campaign/presentation/hooks/useVerifyDonation";
import { queryClient } from "index";
import KroLoadingIndicator, { LoaderType } from "features/components/loader/kroCircularIndicator";
import KroSuccessModal from "./kroSuccessModal";
import { useCampaignDonateForm } from "../../context/campaignDonateFormProvider";

const DonationCompletedPage = () => {
  const { id: campaignId } = useParams<{ id: string }>();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [verificationComplete, setVerificationComplete] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const { formData } = useCampaignDonateForm();

  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  const verifyDonationMutation = useVerifyDonation(
    () => {
      setVerificationComplete(true);
      setShowSuccessModal(true);
    },
    () => {
      setVerificationComplete(true);
      setShowSuccessModal(true);

      queryClient.invalidateQueries({
        queryKey: ["fetchCampaign", campaignId]
      });
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (verificationComplete || !pageLoaded) return;

    if (!sessionId && !campaignId) {
      setVerificationComplete(true);
      setShowSuccessModal(true);
      return;
    }

    if (sessionId && campaignId) {
      verifyDonationMutation.mutate({
        id: campaignId,
        reference: sessionId
      });
    }
    else if (campaignId && !sessionId) {
      setVerificationComplete(true);
      setShowSuccessModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, campaignId, verificationComplete, pageLoaded]);

  // const defaultOptions = {
  //   loop: false,
  //   autoplay: true,
  //   animationData: animationData,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice"
  //   }
  // };

  if (sessionId && campaignId && verifyDonationMutation.isPending && !verificationComplete) {
    return <KroLoadingIndicator type={LoaderType.FIXED} />;
  }

  return (
    <>
      <KroSuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        firstName={formData.firstName ?? ""}
        campaignId={campaignId ?? ""}
      />
      <div className="flex min-h-[calc(100vh-250px)] flex-col">
        <div className="absolute inset-0 z-0">
          {/* <Lottie options={defaultOptions} height="100%" width="100%" /> */}
        </div>
        <div className="flex flex-grow items-center justify-center px-4">
          <div className="w-full max-w-[608px]">
            <div className="flex flex-col items-center rounded-3xl border border-neutral-200 p-6">
              <img
                src="/assets/icons/donation_success.svg"
                alt="giving"
                className="mb-1"
              />
              <p className="mb-2 text-center font-inter text-H_7 tracking-[-0.005em]">
                Donation successful!
              </p>
              <p className="text-base leading-6 mb-4 text-center font-inter font-normal tracking-[-0.005em] text-neutral-400">
                Your donation was successful and will
                <br />
                make a big difference.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DonationCompletedPage; 
